// @flow

import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';

import { CROSS_SELL_ROUTE_MAP } from 'client/constants/routes';
import BREAKPOINTS from 'client/constants/styles/breakpoints';
import COLORS from 'client/constants/colors';
import CrossSellButton, {
  CrossSellBenefit,
  CrossSellHeader,
  CrossSellPrice,
} from 'client/components/crossSell/CrossSellButton';

import { SectionHeader } from 'routes/cart/components/shared';

import type { IfpAppType, AppType } from 'web-core/types/ifp-app';

const CrossSellContainer = styled.fieldset`
  background: ${COLORS.GRAY_6};
  border: 1px solid ${COLORS.GRAY_5};
  margin-bottom: 1.125rem;
  margin-top: 2rem;
  padding: 1.25rem;

  @media screen and (max-width: ${BREAKPOINTS.MEDIUM}) {
    border-left-width: 0;
    border-right-width: 0;
  }
`;

const CART_SOURCE_QUERY_STRING = '?source=cart';

type CrossSellButtonTranslationType = {
  key: AppType,
  benefit: string,
  header: string,
  price: string,
};

type CartCrossSellSectionProps = {
  crossSellTranslations: {
    buttonTranslations: Array<CrossSellButtonTranslationType>,
    caption: string,
  },
  dentalApp: IfpAppType,
  healthApp: IfpAppType,
  excludeTypes: Array<string>,
  postCrossSell: Function,
  visionApp: IfpAppType,
};

const CartCrossSellSection = (props: CartCrossSellSectionProps) => {
  const {
    crossSellTranslations: { buttonTranslations, caption },
    dentalApp,
    excludeTypes,
    healthApp,
    postCrossSell,
    visionApp,
  } = props;
  const CrossSellCopy = (type: AppType) => {
    const copy = _.find(buttonTranslations, { key: type });
    return copy ? (
      <div>
        <CrossSellHeader>
          <span>{copy.header}</span>
        </CrossSellHeader>
        <CrossSellPrice>
          <span>{copy.price}</span>
        </CrossSellPrice>
        <CrossSellBenefit>
          <span>{copy.benefit}</span>
        </CrossSellBenefit>
      </div>
    ) : null;
  };

  const createCrossSellHandler = async (targetAppType: AppType) => {
    const sourceApp = healthApp || dentalApp || visionApp;
    const sourceAppId = _.get(sourceApp, 'app_id');
    if (sourceAppId) {
      await postCrossSell({
        target_app_type: targetAppType,
        source_app_id: sourceAppId,
        context: 'cart',
        shared_resources: ['address', 'member'],
      });
      window.location = `${CROSS_SELL_ROUTE_MAP[targetAppType]}${CART_SOURCE_QUERY_STRING}`;
    }
    return null;
  };

  return (
    <div className="center-col-500">
      <CrossSellContainer>
        <legend>
          <SectionHeader>{caption}</SectionHeader>
        </legend>
        <CrossSellButton
          crossSellHandler={type => createCrossSellHandler(type)}
          excludeTypes={excludeTypes}
          renderCrossSellCopy={CrossSellCopy} />
      </CrossSellContainer>
    </div>
  );
};

export default CartCrossSellSection;
